// AUTO-GENERATED — do NOT edit by hand.
// Regenerated at every `yarn start` / `yarn build` from write-build-info.js.
// v200.41 · source: SHA-256(src/**/{.js,.jsx,.ts,.tsx,.css} + yarn.lock),
// deterministic path order. No env, no git, no asset-manifest.
export const APP_VERSION       = "v6ea5b0e0a1b7-2026-11-05T08:28";
export const APP_BUILD_DATE    = "2026-11-05";
export const APP_BUILD_TIME    = "2026-11-05T08:28:34.439Z";
export const APP_BUILD_MINUTE  = "2026-11-05T08:28";
export const APP_GIT_COMMIT    = "6ea5b0e0a1b7";
export const APP_COMMIT_SOURCE = "src+lock";
